export class CoursePicture {
    image: string;
    imageUrl: string;
}